module.exports = __webpack_public_path__ + "img/Honigloeffel-v1-560.ac6f2d3d.png";